import { useDispatch } from 'react-redux';

import {
  ComboInputElement,
  ComboInputElementProps,
  ComboInputOption,
} from '@opendoor/cinderblocks/growth/novo/inputs/ComboInput';
import Field from '@opendoor/cinderblocks/growth/novo/inputs/Field';

import { trackAnswerChange } from 'src/components/fields/trackAnswerChange';
import { ComboInputQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers, SavedAnswer } from 'src/store/sellerInput';

type ComboInputFieldProps = {
  question: ComboInputQuestion;
  inputProps: Omit<ComboInputElementProps, 'id'>;
};

const ComboInputField: React.FC<ComboInputFieldProps> = ({ question, inputProps }) => {
  const dispatch = useDispatch();

  const onChange = (v: ComboInputOption) => {
    const newValue: SavedAnswer | undefined = v?.value;
    dispatch(changeAnswers([{ key: question.key, answer: newValue ?? null }]));
    trackAnswerChange(question.key, newValue);
  };

  return (
    <Field<ComboInputElementProps>
      InputComponent={ComboInputElement}
      label={question.label}
      helperText={question.helperText}
      input={{
        id: question.key,
        name: question.key,
        placeholder: question.placeholder,
        onChange: onChange,
        ...inputProps,
      }}
    />
  );
};

export default ComboInputField;
